import React from 'react';

const TransportCompanyIcon = ({ ...rest }) => {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_5301_1564)">
        <g opacity="0.2">
          <path d="M32 32.3333V15C32 14.4477 31.5523 14 31 14H28C27.4477 14 27 13.5523 27 13V10C27 9.44772 26.5523 9 26 9H13C12.4477 9 12 9.44772 12 10V32.3333V34H20.3333V29H23.6667V34H32V32.913V32.3333ZM18.6667 25.6667H15.3333V22.3333H18.6667V25.6667ZM18.6667 20.6667H15.3333V17.3333H18.6667V20.6667ZM18.6667 15.6667H15.3333V12.3333H18.6667V15.6667ZM23.6667 25.6667H20.3333V22.3333H23.6667V25.6667ZM23.6667 20.6667H20.3333V17.3333H23.6667V20.6667ZM23.6667 15.6667H20.3333V12.3333H23.6667V15.6667ZM30.3333 25.6667H27V22.3333H30.3333V25.6667ZM30.3333 20.6667H27V17.3333H30.3333V20.6667Z" fill="currentColor"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5301_1564">
          <rect width="44" height="44" rx="12" fill="currentColor"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TransportCompanyIcon;